import { useEffect, useState } from "react";
import { Button, Card, Col, Row, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import Pagination from "../../../common/Pagination/Pagination";
import { Translate } from "../../../Enums/Tranlate";
import CardItem from "./CardItem";
import AddQrCodeValetModal from "./AddQrCodeValetModal";
import QrCodeValetService from "../../../../services/QrCodeValetService";
import Select from "react-select";
import QrCodeGroupingService from "../../../../services/QrCodeGroupingService";
import QRModal from "./QRModal";
import { usePermissions } from "../../../common/permissions";

const QrCodeValet = () => {
	const [data, setData] = useState(null);
	const [addModal, setAddModal] = useState(false);
	const [hasData, setHasData] = useState(null);
	const [qrModal, setQrModal] = useState(false);
	const [item, setItem] = useState({});
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [qrGroup, setQrGroup] = useState("");
	const [qrGroupOptions, setQrGroupOptions] = useState([]);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const qrCodeValetService = new QrCodeValetService();
	const qrCodeGroupingService = new QrCodeGroupingService();
	const Auth = useSelector((state) => state.auth?.auth);
	const { canAdd } = usePermissions();
	const lang = useSelector((state) => state.auth?.lang);
	const search = useSelector((state) => state.auth.search);

	useEffect(() => {
		qrCodeGroupingService?.getList().then((res) => {
			if (res?.status === 200) {
				let data = res?.data?.data?.data?.map((info) => {
					return {
						...info,
						label: info?.name,
						value: info?.id,
					};
				});
				setQrGroupOptions(data);
			}
		});
	}, []);

	return (
		<div className="admin">
			<div className="mb-3">
				<div className="d-flex justify-content-between align-items-center">
					<div>
						<span
							style={{
								fontWeight: "600",
								textTransform: "capitalize",
								color: "#000",
							}}>
							{Translate[lang].qr_code_valet}
						</span>
					</div>
					<div className="add-admin">
						{canAdd("qr_code_valet") && (
							<Button
								variant="primary"
								className="me-2 h-75"
								onClick={() => {
									setItem({});
									setAddModal(true);
								}}>
								<i
									className={`la la-plus ${lang === "en" ? "mr-2" : "ml-2"}`}></i>
								{Translate[lang]?.add} {Translate[lang]?.qr_code_valet}
							</Button>
						)}
					</div>
				</div>
			</div>

			<Row>
				<Col md={3} className="mb-3">
					<label className="text-label">{Translate[lang]?.qr_code_group}</label>
					<Select
						value={qrGroup}
						name="qr_code_group"
						placeholder={Translate[lang]?.select}
						options={qrGroupOptions}
						onChange={(e) => {
							setQrGroup(e);
							setShouldUpdate((prev) => !prev);
						}}
					/>
				</Col>
			</Row>
			<div>
				<div className={`${hasData === 0 ? "text-center" : "table-style"}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr>
									<th>
										<strong>{Translate[lang]?.qr_code_group}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.zone}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.qr_code_number}</strong>
									</th>

									<th>
										<strong>{Translate[lang]?.floor}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.parking_slot}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.login_number}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.action}</strong>
									</th>
								</tr>
							</thead>
							<tbody>
								{data?.length > 0 &&
									data?.map((item, index) => {
										return (
											<CardItem
												key={index}
												index={index}
												item={item}
												setShouldUpdate={setShouldUpdate}
												setItem={setItem}
												setAddModal={setAddModal}
												setQrModal={setQrModal}
											/>
										);
									})}
							</tbody>
						</Table>
					)}
					{(hasData === 0 || !qrGroup?.value) && (
						<>
							{!qrGroup?.value ? (
								<div
									className="d-flex align-items-center justify-content-center"
									style={{ minHeight: "60vh" }}>
									<h2 style={{ color: "#777" }}>
										{Translate[lang].select} {Translate[lang].qr_code_group}
									</h2>
								</div>
							) : (
								""
							)}
							{hasData === 0 && <NoData />}
						</>
					)}
					{!!qrGroup?.value && (
						<Pagination
							setData={setData}
							service={qrCodeValetService}
							shouldUpdate={shouldUpdate}
							setHasData={setHasData}
							setLoading={setLoading}
							search={search}
							param={{
								qr_group_id: qrGroup?.value,
							}}
						/>
					)}
				</div>
			</div>
			{addModal && (
				<AddQrCodeValetModal
					addModal={addModal}
					setShouldUpdate={setShouldUpdate}
					setAddModal={() => setAddModal(false)}
					item={item}
				/>
			)}
			{qrModal && (
				<QRModal
					item={item}
					modal={qrModal}
					setShouldUpdate={setShouldUpdate}
					setModal={() => setQrModal(false)}
				/>
			)}
		</div>
	);
};
export default QrCodeValet;
